var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * When `fire(...args)` is invoked on an `EventEmitter`, the provided `args` are propagated
 * to all registered handlers. Handlers can be registered using `on`. */
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.handlers = [];
    }
    EventEmitter.prototype.on = function (handler) {
        var _this = this;
        this.handlers.push(handler);
        return {
            dispose: function () { _this.handlers = _this.handlers.filter(function (h) { return h !== handler; }); }
        };
    };
    EventEmitter.prototype.fire = function (event) {
        var e_1, _a;
        this.current = event;
        try {
            for (var _b = __values(this.handlers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var h = _c.value;
                h(event);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    EventEmitter.prototype.dispose = function () {
        this.handlers = [];
    };
    return EventEmitter;
}());
export { EventEmitter };
